import { Component, OnInit } from '@angular/core';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../providers/login.service';
import { FormControl, Validators } from '@angular/forms';
import { createSession } from '../../common/sessionHandler';
import { ApiPromisefactory } from '../../providers/promise.factory';
import { MethodSummary } from '../../models/methodSummary';
import { Params } from '../../models/params';
import { MethodServiceJava } from '../../providers/methodsService.java';
import { MethodServiceSwift } from '../../providers/methodsService.swift';
import { EnumSummary } from '../../models/enumSummary';
import { EnumService } from '../../providers/enumService';
import { LanguageSettings } from '../../providers/languageSettings.service';

@Component({
  selector: 'app-enummodule',
  templateUrl: './enummodule.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})


export class EnumModuleComponent {

    language = 'html';
    className:String = "";
    type:string="";

    enums:EnumSummary[];

    selected:String = 'Java';
    languageSubscription:any;

    constructor(private _loginService: LoginService,
        private router: Router,
        private promiseSvc: ApiPromisefactory,
        private enumService: EnumService,
        private route: ActivatedRoute,
        private languageSetting: LanguageSettings
    ) {
    //this.methods = methodService.getSGBLEConnectMethods();
    }

   ngOnInit() {
    this.selected = this.languageSetting.getSelectedLanguage()
    this.languageSubscription = this.languageSetting.getLanguageChangeEmitter().subscribe(
      item => this.onValChange(item)
    )

    this.route.data
      .subscribe((data: { className: string; type:string}) => {
        if (data.type=='error')
          this.enums = this.enumService.getErrorEnums(data.className);
        else
        switch (data.className){
          case "SGBLEConnectionState":
            this.enums = this.enumService.getBLEStateEnums();
            break;
          case "SGDeviceProximityState":
          this.enums = this.enumService.getProxStateEnums();
            break;
          case "SGQRConnectionState":
            this.enums = this.enumService.getQRConnectStateEnums();
            break;
          case "SGPlayerSessionState":
            this.enums = this.enumService.getSessionStateEnums();
            break;
          case "SGPlayerProfileState":
            this.enums = this.enumService.getPlayerProfileEnums();
            break;
          case "SGLogLevel":
            this.enums = this.enumService.getLogLevelEnums();
            break;
        }
        this.className=data.className;
        this.type=data.type;

      });
    }

    onValChange(val){
      //this.languageSetting.setSelectedLanguage(val);
      this.selected=this.languageSetting.getSelectedLanguage();
      console.log(val);
    }

}
